import BaseService from "vamos/cockpit/base/services/BaseService";
import VamosComponent from "vamos/cockpit/Component";
import { Product } from "vamos/cockpit/model/odata/VamosModel";
import Filter from "sap/ui/model/Filter";
import V4Context from "sap/ui/model/odata/v4/Context";

export default class ProductService extends BaseService {

    constructor(component: VamosComponent) {
        super(component, "/Products");
    }

    public async checkCountAndReturnSingleProduct(filter: Filter): Promise<Product> {
        const listBinding = this.model.bindList(`${this.path}`, undefined, undefined, filter, { $count: true });
        const contexts:V4Context[] = await listBinding.requestContexts(0,1);

        const availableProducts = listBinding.getCount();
        let product: Product = null;
        if (availableProducts === 1) {
            product = contexts[0].getObject() as Product;

        }
        listBinding.destroy();
        return product;
    }
}